import { useCallback, useMemo } from "react";
import { useI18nName } from "@hopper-b2b/i18n";
import type { TravelerDeleteProps } from "./TravelerDelete";
import { travelerApi } from "~core-traveler/store";

export const useTravelerDelete = ({
  traveler,
  onDelete,
}: TravelerDeleteProps) => {
  const [deleteTraveler] = travelerApi.useDeleteTravelerMutation();
  const handleOnDelete = useCallback(() => {
    deleteTraveler(traveler);
    onDelete?.(traveler);
  }, [deleteTraveler, onDelete, traveler]);

  const { formatFullName } = useI18nName();
  return useMemo(
    () => ({
      name: formatFullName(traveler.name),
      handleOnDelete,
    }),
    [formatFullName, handleOnDelete, traveler.name]
  );
};
